import { createActionsHook, StoreActionApi } from 'react-sweet-state';

import {
  createDataHook,
  createGetAction,
  createLoadingHook,
  createRestActions,
  createRestStore,
  RestStoreState,
} from '@intelliarts/ia-react-template';

import { createMutationFailedCheck } from '../../../utils/restMutation';
import { EmployeeStatus } from '../../Employee/models/EmployeeStatus';
import { StatusHistoryWithEmployee } from '../../Employee/models/StatusHistoryWithEmployee';

type LeavesPageStoreState = RestStoreState<StatusHistoryWithEmployee>;

const actionConfig = {
  resourcePath: '/status-histories',
};

const genericActions = createRestActions<StatusHistoryWithEmployee>(actionConfig);

const leavesPageActions = {
  ...genericActions,
  loadLeavesHistories: (status: EmployeeStatus, from: string, to: string) =>
    async ({ dispatch }: StoreActionApi<LeavesPageStoreState>) => {
      const getAction = createGetAction<StatusHistoryWithEmployee>({
        resourcePath: `${actionConfig.resourcePath}?status=${encodeURIComponent(status)}&from=${from}&to=${to}`,
      });
      await dispatch(getAction());
    },
};

export const LeavesHistoryStore = createRestStore<StatusHistoryWithEmployee>({
  actions: leavesPageActions,
  actionConfig,
  containerDisplayName: 'leaves-page-container',
  onInitAction: null,
});

export const useLeavesPageData = createDataHook(LeavesHistoryStore);
export const useLeavesPageIsLoading = createLoadingHook(LeavesHistoryStore);
export const useLeavesPageActions = createActionsHook(LeavesHistoryStore);
export const didLeavesHistoryMutationFail = createMutationFailedCheck(actionConfig.resourcePath);
